import { render, staticRenderFns } from "./NewFeedbackMenu.vue?vue&type=template&id=02c8bdb4"
import script from "./NewFeedbackMenu.vue?vue&type=script&lang=js"
export * from "./NewFeedbackMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports